import CustomZObject from './CustomZObject.js';

export default class XYInterface extends CustomZObject {
    constructor(zobject) {
        super(zobject);

        this.x = 0.5;
        this.y = 0.5;

        this.newInlet("xy", ([coord]) => this.onXY(coord));
        this.newOutlet("xy");
    }

    onXY([x,y]) {
        this.setXY(x,y);
    }


    sendCoordinates() {
        this.sendMessage("xy", [this.x, this.y]);
    }

    setXY(x,y) {
        this.x = x;
        this.y = y;

        this.sendCoordinates();
    }

    set x(x) {
        this._x = x;
    }

    set y(y) {
        this._y = y;
    }

    get x() {
        return this._x;
    }

    get y() {
        return this._y;
    }

    getJson() {
        return {
            ... super.getJson(),
            x: this.x,
            y: this.y
        };
    }

    fromJson(json, copy) {
        super.fromJson(json, copy);

        this.x = json.x;
        this.y = json.y;
    }
}

